﻿import { IEwtSummary } from '../ewt-summary';
import { IEwtCounts } from '../ewt-counts';

export interface IUnmatchedPair {
    recipientCenter: string;
    recipientId: number;
    recipientAlias: string;
    recipientBloodType: string;
    oTiterString: string;
    maxDonorAge: number;
    minHLAMatch: number;
    cPRA4: number;
    rAge: number;
    donorBloodType: string;
    firstDonorBloodType: string;
    dAge: string;
    dmp: string;
    rmPa: number;
    rmPb: number;
    rmPc: number;
    pmPa: number;
    pmPb: number;
    pmPc: number;
    erosion: number;
    dialysis: string;
    dialysisMonths: number;
    ewt: string;
    wtv: string;
    wait: number;
    exportableDaysInNkr: number;
    ssdHit: number;
    clc: number;
    fclc: number;
    usableCLC: number;
    cprScore: number;
    cprScore2: number;
    onlyDonorIdMatchC: number;
    onlyDonorMatchCAlias: string;
    onlyDonorMatchCCenter: string;
    rexmStatus: string;
    highPra: boolean;
    pediatric: boolean;
    targetsWait: boolean;
    targetsClc: boolean;
    ewtSummary: IEwtSummary;
    initialCount: IEwtCounts;
    declineRatio: number;
}
